export const API_BASE_URL = "https://niveshapi.uttarakhandtourism.gov.in/api";
export const INVEST_UK_WEBSITE_URL = 'https://investuttarakhand.uk.gov.in/'
export const BASE_URL = "https://niveshapi.uttarakhandtourism.gov.in";
export const TOURISM_WEBSITE_URL = "https://uttarakhandtourism.gov.in"
export const MSY_WEBSITE_URL = "https://msy.uk.gov.in"
export const NIVESH_WEBSITE_URL = "https://nivesh.uttarakhandtourism.gov.in"